import { useEffect, useState } from 'react';
import { useStore, isPremium, trialMsRemaining } from '../store/useStore';

function fmt(ms: number): string {
  const d = Math.floor(ms / 86_400_000);
  const h = Math.floor((ms % 86_400_000) / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  if (d > 0) return `${d}d ${h}h`;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

/** Compact header chip showing subscription status / trial countdown. */
export function TrialBanner() {
  const subscription = useStore((s) => s.subscription);
  const openPaywall = useStore((s) => s.openPaywall);
  const [, tick] = useState(0);

  // Re-render every 30s so the countdown stays fresh.
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 30_000);
    return () => clearInterval(t);
  }, []);

  if (subscription.plan === 'lifetime' && subscription.alphaTester) {
    return (
      <span className="rounded-full border border-brand-400/30 bg-brand-500/15 px-2.5 py-1 text-[9px] font-bold uppercase tracking-wider text-brand-600 dark:text-brand-400">
        Alpha · Lifetime
      </span>
    );
  }

  if (subscription.plan === 'lifetime') {
    return (
      <span className="rounded-full border border-emerald-300 dark:border-emerald-400/30 bg-emerald-500/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
        Lifetime
      </span>
    );
  }

  if (
    subscription.plan === 'monthly' ||
    subscription.plan === 'quarterly' ||
    subscription.plan === 'annual'
  ) {
    return (
      <span className="rounded-full border border-brand-300 dark:border-brand-400/30 bg-brand-500/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-600 dark:text-brand-400">
        Premium
      </span>
    );
  }

  if (subscription.plan === 'trial' && isPremium(subscription)) {
    return (
      <span className="rounded-full border border-emerald-300 dark:border-emerald-400/30 bg-emerald-500/15 px-2.5 py-1 text-[11px] font-bold text-emerald-600 dark:text-emerald-400">
        Trial · {fmt(trialMsRemaining(subscription))} left
      </span>
    );
  }

  // Register #16 (Shirann): the primary revenue CTA must LOOK tappable —
  // brand-solid, not a muted grey chip that reads as disabled. Min 44px
  // hit area via padding + margin (visual height stays header-friendly).
  return (
    <button
      onClick={openPaywall}
      className="min-h-9 rounded-full bg-brand-600 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-md shadow-brand-600/30 transition-all hover:bg-brand-500 active:scale-95"
      style={{ minHeight: 36, margin: 4 }}
    >
      ✨ Go Premium
    </button>
  );
}
